import { AuthError } from "@aws-amplify/auth";
import { AuthContext } from "hooks/authProvider/authProvider";
import { type FC, useCallback, useContext } from "react";
import type { SubmitHandler } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { SignInPage } from "routes/SignInPage/SignInPage";
import { toastError } from "utils/toast-utils";

export type SignInInput = {
  email: string;
  password: string;
};

const SignInPageContainer: FC = () => {
  const { signIn } = useContext(AuthContext);
  const navigate = useNavigate();
  const onSignIn: SubmitHandler<SignInInput> = useCallback(
    async (input: SignInInput) => {
      try {
        await signIn(input);
        navigate("/dashboard");
      } catch (error) {
        if (error instanceof AuthError) {
          toastError(error.message);
        } else {
          toastError("予期せぬエラーが発生しました");
        }
      }
    },
    [navigate, signIn],
  );

  return <SignInPage onSignIn={onSignIn} />;
};

export default SignInPageContainer;
